function initiateCraftRumAddToCart() {
  document
    .querySelectorAll('.my-craft-rum-add-to-cart-block')
    .forEach(block => {
      new window.MyCraftRumAddToCart(block);
    });
}

if (!window.MyCraftRumAddToCart) {
  window.MyCraftRumAddToCart =
    class MyCraftRumAddToCart {
      constructor(blockElement) {
        this.blockElement = blockElement;
        this.addToCartButton = blockElement.querySelector('.add-to-cart-button');
        this.buyNowButton = blockElement.querySelector('.buy-now-button');
        this.cartForm = blockElement.querySelector('.cart-form');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.validationContainer = blockElement.querySelector('.validation-messages');
        this.priceElements = {
          base: blockElement.querySelector('[data-base-price]'),
          extras: blockElement.querySelector('[data-extras-price]'),
          total: blockElement.querySelector('[data-total-price]')
        };

        this.startVariant = JSON.parse(blockElement.dataset.product);
        this.variantsArray = window.__CGC.craftSpiritVariants;

        // Get settings from block data attributes
        this.settings = {
          requiredSpices: parseInt(blockElement.dataset.requiredSpices) || 5,
          requireRumType: blockElement.dataset.requireRumType !== 'false',
          requireBottleCount: blockElement.dataset.requireBottleCount !== 'false'
        };

        this.inputs = {
          author: null,
          name: null,
          tagLine: null,
        };

        // Selection state
        this.selections = {
          spices: [],
          sweetener: "none",
          bottleCount: this.startVariant.option1 || "One Bottle",
          rumType: this.startVariant.option2 || "Standard",
          finish: this.startVariant.option3 || "None",
          sealColour: "gold",
        };

        this.prices = {
          base: parseInt(this.priceElements.base.dataset.basePrice) || 0,
          current: parseInt(this.startVariant.price) || 0
        };

        this.labelType = "Normal Label";

        this.init();
      }

      init() {
        this.addEventListeners();
        this.handleVariantChange();
        this.validateSelections();
      }

      addEventListeners() {
        // Listen for input field updates
        document.addEventListener('input-changed', (e) => {
          this.updateInputs(e.detail.input);
          this.validateSelections();
        });

        // Listen for label type updates
        document.addEventListener('my-craft-spirit-label-changed', (e) => {
          this.labelType = e.detail.labelType;
        });

        // Listen for custom events for rum type/strength
        document.addEventListener('spices-changed', (e) => {
          this.selections.spices = e.detail.selectedSpices;
          this.validateSelections();
        });

        // Listen for custom events for rum sweetener
        document.addEventListener('rum-sweetener-changed', (e) => {
          this.selections.sweetener = e.detail.selectedType;
          this.validateSelections();
        });

        // Listen for custom events for rum type/strength
        document.addEventListener('strength-changed', (e) => {
          this.selections.rumType = e.detail.value;
          this.handleVariantChange();
          this.validateSelections();
        });

        // Listen for custom events for rum size/quantity
        document.addEventListener('size-changed', (e) => {
          this.selections.bottleCount = e.detail.value;
          this.handleVariantChange();
          this.validateSelections();
        });

        // Listen for custom events for rum finish
        document.addEventListener('finish-changed', (e) => {
          this.selections.finish = e.detail.value;
          this.handleVariantChange();
          this.validateSelections();
        });

        // Listen for custom events for wax seal colour
        document.addEventListener('seal_colour-changed', (e) => {
          this.selections.sealColour = e.detail.value;
          this.validateSelections();
        });

        // Add to cart button
        this.addToCartButton.addEventListener('click', () => {
          this.addToCart();
        });

        // Buy now button
        if (this.buyNowButton) {
          this.buyNowButton.addEventListener('click', () => {
            this.buyNow();
          });
        }
      }

      updateInputs(input) {
        const field = input.name.replaceAll('properties[', '').replaceAll(']', '');
        this.inputs[field] = input.value;
      }

      async handleVariantChange() {
        const selectedOption = `${this.selections.bottleCount}_${this.selections.rumType}_${this.selections.finish}`;
        const variant = this.variantsArray[selectedOption.replaceAll(' ', '_').toLocaleLowerCase()];
        if (!variant) return;

        this.prices.current = +variant.price || 0;

        const variantIdInput = this.cartForm.querySelector('[name="id"]');
        if (variantIdInput) {
          variantIdInput.value = +variant.id;
        }

        this.updatePricing();
        this.validateSelections();
      }

      extractVariantOption(variant, optionName) {
        // Try to find the option by matching with variant options
        if (variant.options) {
          const optionIndex = variant.product?.options?.findIndex(opt => opt.name === optionName);
          if (optionIndex !== -1 && variant.options[optionIndex]) {
            return variant.options[optionIndex];
          }
        }

        // Fallback: try to extract from variant title
        if (variant.title && variant.title.includes('/')) {
          const options = variant.title.split(' / ');
          // This is a simple fallback - you may need to adjust based on your variant title structure
          return options.find(opt => opt.includes(optionName.split(' ')[0]));
        }

        return null;
      }

      getCurrentVariant() {
        // Get current variant from product form or variant picker
        const productForm = document.querySelector('[action*="/cart/add"]');
        if (productForm) {
          const variantIdInput = productForm.querySelector('[name="id"]');
          if (variantIdInput && window.product && window.product.variants) {
            return window.product.variants.find(v => v.id == variantIdInput.value);
          }
        }
        return null;
      }

      validateSelections() {
        const validations = [];

        if (!this.inputs.author) {
          validations.push('author');
        }

        if (!this.inputs.name) {
          validations.push('name');
        }

        if (!this.inputs.tagline) {
          validations.push('tagline');
        }

        // Check spices
        if (this.settings.requiredSpices > 0 && this.selections.spices.length < this.settings.requiredSpices) {
          validations.push('spices');
        }

        this.updateValidationDisplay(validations);

        const isValid = validations.length === 0;
        this.addToCartButton.disabled = !isValid;
        if (this.buyNowButton) {
          this.buyNowButton.disabled = !isValid;
        }

        return isValid;
      }

      updateValidationDisplay(validations) {
        const validationMessages = this.blockElement.querySelectorAll('.validation-message');

        // Hide all validation messages first
        validationMessages.forEach(msg => {
          msg.style.display = 'none';
        });

        // Show container if there are validations
        if (validations.length > 0) {
          this.validationContainer.style.display = 'block';

          // Show specific validation messages
          validations.forEach(validation => {
            const msg = this.blockElement.querySelector(`[data-validation="${validation}"]`);
            if (msg) {
              msg.style.display = 'flex';
            }
          });
        } else {
          this.validationContainer.style.display = 'none';
        }
      }

      updatePricing() {
        // The variant price includes all options, so we use that as the total
        const total = this.prices.current;
        const extrasCost = this.prices.current - this.prices.base;

        // Update DOM
        this.priceElements.extras.textContent = this.formatPrice(extrasCost);
        this.priceElements.extras.parentElement.style.display = extrasCost > 0 ? 'flex' : 'none';

        this.priceElements.total.textContent = this.formatPrice(total);
        this.priceElements.total.dataset.totalPrice = total;
      }

      formatPrice(priceInCents) {
        return new Intl.NumberFormat('en-GB', {
          style: 'currency',
          currency: 'GBP'
        }).format(priceInCents / 100);
      }
      
      async addToCart() {
        if (!this.validateSelections()) return;

        this.setLoading(true);

        try {
          const formData = this.buildFormData();

          const craftSpiritCheckout = new CraftSpiritCheckout(this, formData);
          await craftSpiritCheckout.addToCart();
          
          const containerModal = this.blockElement.closest('quick-add-modal');
          if (containerModal) {
            containerModal.hide();
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          alert('Sorry, there was an error adding this item to your cart. Please try again.');
        } finally {
          this.setLoading(false);
        }
      }

      async buyNow() {
        if (!this.validateSelections()) return;

        this.setLoading(true);

        try {
          await this.addToCart();
          // Redirect to checkout
          window.location.href = '/checkout';
        } catch (error) {
          this.setLoading(false);
        }
      }

      buildFormData() {
        const navystrong = this.selections.rumType.toLowerCase() == "overproof"
          ? "yes"
          : "no";

        const wrap = this.selections.finish === "Gift Wrap" || this.selections.finish === "Wax Seal and Gift Wrap"
          ? "yes"
          : "no";

        const wax = this.selections.finish === "Wax Seal" || this.selections.finish === "Wax Seal and Gift Wrap"
          ? this.selections.sealColour
          : "none";

        const formData = new FormData(this.cartForm);

        formData.append('properties[label]', this.labelType);
        formData.append('properties[author]', this.inputs.author || "");
        formData.append('properties[name]', this.inputs.name || "");
        formData.append('properties[tagLine]', this.inputs.tagline || "");
        formData.append('properties[type]', this.selections.rumType.toUpperCase() || "STANDARD STRENGTH");
        formData.append('properties[navystrong]', navystrong);
        formData.append('properties[botanicals]', this.selections.spices || []);
        formData.append('properties[infusion]', this.selections.sweetener.toUpperCase() || "none");
        formData.append('properties[wax]', wax);
        formData.append('properties[wrap]', wrap);

        return formData;
      }

      setLoading(loading) {
        const buttonText = this.addToCartButton.querySelector('.button-text');
        const spinner = this.addToCartButton.querySelector('.loading-spinner');

        if (loading) {
          buttonText.style.display = 'none';
          spinner.style.display = 'block';
          this.addToCartButton.disabled = true;
        } else {
          buttonText.style.display = 'block';
          spinner.style.display = 'none';
          this.addToCartButton.disabled = !this.validateSelections();
        }
      }

      async refreshCart() {
        try {
          const response = await fetch('/cart.js');
          const cart = await response.json();

          // Dispatch cart updated event
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { cart }
          }));
          return cart;
        } catch (error) {
          console.error('Error refreshing cart:', error);
        }
        return null;
      }
    }
  initiateCraftRumAddToCart();
}

document.addEventListener('DOMContentLoaded', () => {
  initiateCraftRumAddToCart();
});

document.addEventListener('modal-opened', () => {
  initiateCraftRumAddToCart();
});
